// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { getData } from "country-list";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Toast from "views/Toast/Toast";
import axios from "axios";
import { api_url } from "redux/config.js";
import CustomSelect from "components/CustomSelect/CustomSelect"
import Success from "components/Typography/Success";
import { verifyEmail } from "utils/Validate";
import { withTranslation } from "react-i18next";
import { t } from "i18next";

// ==============================================
// IMPORTANT: Replace 0x4AAAAAACqy6-i0ZuEFcAu3 below
// with your actual Cloudflare Turnstile site key
// ==============================================
const TURNSTILE_SITE_KEY = '0x4AAAAAACqy6-i0ZuEFcAu3';

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: [],
      successed: false,
      turnstileToken: null,
      turnstileLoaded: false,
      formData: {
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirm: "",
        company_name: "",
        company_address: "",
        tax_id: "",
        tax_office: "",
        country: null,
        city: ""
      }
    };
    this.turnstileRef = React.createRef();
  }

  componentDidMount() {
    let countries = [];
    getData().map(item => {
      countries.push({
        value: item.code,
        label: item.name
      });
      return null;
    });
    this.setState({ countries });

    // Load Turnstile script
    if (!document.getElementById('turnstile-script')) {
      const script = document.createElement('script');
      script.id = 'turnstile-script';
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad';
      script.async = true;
      script.defer = true;

      window.onTurnstileLoad = () => {
        this.renderTurnstile();
      };

      document.head.appendChild(script);
    } else if (window.turnstile) {
      this.renderTurnstile();
    }
  }

  componentWillUnmount() {
    if (window.turnstile && this.turnstileWidgetId) {
      window.turnstile.remove(this.turnstileWidgetId);
    }
  }

  renderTurnstile = () => {
    if (this.turnstileRef.current && window.turnstile) {
      this.turnstileWidgetId = window.turnstile.render(this.turnstileRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: (token) => {
          this.setState({ turnstileToken: token });
        },
        'expired-callback': () => {
          this.setState({ turnstileToken: null });
        },
        'error-callback': () => {
          this.setState({ turnstileToken: null });
        },
        theme: 'light',
      });
      this.setState({ turnstileLoaded: true });
    }
  }

  resetTurnstile = () => {
    if (window.turnstile && this.turnstileWidgetId) {
      window.turnstile.reset(this.turnstileWidgetId);
      this.setState({ turnstileToken: null });
    }
  }

  verfiyForm = () => {
    const { username, email, password, password_confirm } = this.state.formData;
    if (username.length === 0) {
      Toast(400, t('Please enter user name'));
      return false;
    }
    if (!verifyEmail(email)) {
      Toast(400, t('Invalid email address!'));
      return false;
    }
    if (password.length < 6) {
      Toast(400, t('Password should be at least 6 letters'));
      return false;
    }
    if (password !== password_confirm) {
      Toast(400, t('Password confirm mismatched'));
      return false;
    }
    if (!this.state.turnstileToken) {
      Toast(400, t('Please complete the CAPTCHA verification'));
      return false;
    }
    return true;
  };

  registerUser = () => {
    if (this.verfiyForm()) {
      this.props.dispatch({ type: "LOAD_START" });
      const { password_confirm, ...data } = this.state.formData;
      axios({
        url: api_url + "auth/signup",
        method: "POST",
        data: {
          ...data,
          turnstileToken: this.state.turnstileToken
        }
      })
        .then(response => {
          this.props.dispatch({ type: "LOAD_END" });
          if (response.data.success) {
            this.setState({
              successed: true
            });
            Toast(200, t('Successfully registered!'));
          } else {
            Toast(400, response.data.error);
            this.resetTurnstile();
          }
        })
        .catch(errors => {
          this.props.dispatch({ type: "LOAD_END" });
          Toast(500);
          this.resetTurnstile();
        });
    }
  };

  setFormData = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      }
    });
  };

  render() {
    if (this.props.user.isLoggedIn === true) {
      return <Redirect to="/" />;
    }
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={8} md={8}>
            <form>
              <Card className={classes.cardSignup}>
                <h2 className={classes.cardTitle}>{t('Register')}</h2>

                {this.state.successed && (
                  <Success>
                    <h1 className={classes.center}>
                      {t('Successfully registered, please check your email to activate account.')}
                    </h1>
                  </Success>
                )}
                {!this.state.successed && (
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("username", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Username")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("first_name", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("First name")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("last_name", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Last name")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("email", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Email address")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("password", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "password",
                            placeholder: t("Password")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData(
                                "password_confirm",
                                e.target.value
                              ),
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "password",
                            placeholder: t("Confirm Password")
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("company_name", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Company Name")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData(
                                "company_address",
                                e.target.value
                              ),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Company Address")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("tax_id", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Tax ID")
                          }}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("tax_office", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("Tax Office")
                          }}
                        />
                        <CustomSelect
                          // store only the option's value — the whole {value,label} object
                          // cannot be written into the STRING country column server-side
                          onChange={country => {
                            this.setFormData("country", country ? country.value : null);
                          }}
                          placeholder="Country"
                          options={this.state.countries}
                        />
                        <CustomInput
                          formControlProps={{
                            onChange: e =>
                              this.setFormData("city", e.target.value),
                            fullWidth: true
                          }}
                          inputProps={{
                            placeholder: t("City")
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                    {/* Cloudflare Turnstile CAPTCHA */}
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                      <div ref={this.turnstileRef}></div>
                    </div>

                    <div className={classes.center}>
                      <Button
                        onClick={() => this.registerUser()}
                        round
                        color="primary"
                      >
                        {t('Get started')}
                      </Button>
                      <Button href="/auth/login" simple color="primary">
                        {t('Log in')}
                      </Button>
                    </div>
                  </CardBody>
                )}
              </Card>
            </form>
          </GridItem>
        </GridContainer>

      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(
  withTranslation()(withStyles(registerPageStyle)(RegisterPage))
);
